export default "__VITE_ASSET__NWpjnW9P__"